var installedModules = {};
var moduleToHandlerMapping = {
	27751: {
		getter: () => (() => (__webpack_require__(86326))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	74552: {
		getter: () => (() => (__webpack_require__(51171))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react-router-dom",
	},
	23659: {
		getter: () => (() => (__webpack_require__(35623))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	6139: {
		getter: () => (() => (__webpack_require__(15882))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@frontend/feature-monitor",
	},
	44337: {
		getter: () => (() => (__webpack_require__(44691))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react-i18next",
	},
	67471: {
		getter: () => (() => (__webpack_require__(40680))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "i18next",
	},
	91227: {
		getter: () => (() => (__webpack_require__(56550))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "launchdarkly-react-client-sdk",
	},
	8871: {
		getter: () => (() => (__webpack_require__(71281))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@frontend/dynamic-wrapper",
	},
	14981: {
		getter: () => (() => (__webpack_require__(94295))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@frontend/you-shared-ui",
	}
};
var initialConsumes = [27751,74552,23659,6139,44337,67471,91227,8871];
__webpack_require__.federation.installInitialConsumes = () => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping:moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}))
var chunkMapping = {
	"792": [
		27751,
		74552,
		23659,
		6139,
		44337,
		67471,
		91227,
		8871
	],
	"850": [
		14981
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}